import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ReceptionApiAdapter } from '../adapters/ReceptionApiAdapter';
import { Reception, ReceptionListItem } from '../models/Reception';
import { ReceptionService } from '../services/ReceptionService';

/**
 * Hook para eliminar una recepción
 */
export const useDeleteReception = () => {
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new ReceptionApiAdapter(httpClient);
  const receptionService = new ReceptionService(apiAdapter);

  return useMutation({
    mutationFn: (reception: Reception | ReceptionListItem) =>
      receptionService.deleteReception(reception),
    onSuccess: (_, reception) => {
      // Invalidar queries de lista
      queryClient.invalidateQueries({ queryKey: ['receptions'] });
      queryClient.invalidateQueries({ queryKey: ['receptions-simple'] });
      // Remover del cache el detalle si existe
      queryClient.removeQueries({ queryKey: ['reception', reception.id] });
    },
  });
};

